import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "../../MissionAndVission/MissionContact/MissionContact.css";
import Heading from "../../../utls/Heading";
const TechLastBanner = () => {
  return (
    <>
      <div className="mission-contact ew-lastbanner">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <Heading className="headings contact-Heading text-white">
                <span className="contact-h1-span">Ready to</span> Elevate Your
                Travel Knowledge?
              </Heading>
              <p className="mission-contact-p">
                Sign up for our upcoming webinars or explore past sessions for
                valuable insights.
              </p>
              <div className="carouselCaption">
                <a href="/contact">
                  <button className="btn bg-transparent text-white mt-md-3 grotesk-headings fw-bold">
                    GET IN TOUCH
                  </button>
                </a>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="contact-image-m">
                <LazyLoadImage
                  src="https://blueberrywebsites.azureedge.net/bbt/images/techlastbanner.png"
                  alt=""
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TechLastBanner;
